import { useReactiveVar } from '@apollo/client/react';
import dayjs from 'dayjs';
import useDrawer from 'hooks/useDrawer/useDrawer';
import useModal from 'hooks/useModal/useModal';
import useTranslation from 'hooks/useTranslation/useTranslation';
import React from 'react';
import { useForm } from 'react-hook-form';
import { authVar } from 'state/vars';
import DrawerTemplate from 'ui/organisms/Drawer/DrawerTemplate';
import MyProfileStatusConnected from 'ui/organisms/Drawer/variants/MyProfileStatusConnected';
import MyProfileStatusDisconnected from 'ui/organisms/Drawer/variants/MyProfileStatusDisconnected';
import QRCodeValueUtil from 'utils/QRCodeValue/QRCodeValue.util';

const AccessApp: React.FC<React.PropsWithChildren> = () => {
  const { translation } = useTranslation();
  const { handleSubmit } = useForm();
  const { user } = useReactiveVar(authVar);
  const { showModal } = useModal();
  const { hideDrawer } = useDrawer();

  const onSubmit = async () => {
    if (user?.mobileDevices?.find((device) => device.role === 'ACCESS')?.isRegistered)
      showModal({ type: 'disconnectMobileDevice' });
    else hideDrawer();
  };

  const isAccessMobileDeviceRegistered = user?.mobileDevices?.some(
    (device) => device.role === 'ACCESS' && device.isRegistered
  );

  const registrationToken = user?.mobileDevices?.find(
    (device) => device.role === 'ACCESS' && device.registrationToken
  )?.registrationToken;

  return (
    <DrawerTemplate title={translation.atlas_access_app} id="drawer-access-app" onSubmit={handleSubmit(onSubmit)}>
      {isAccessMobileDeviceRegistered ? (
        <MyProfileStatusConnected
          activeSinceDate={dayjs(user?.mobileDevices?.find((device) => device.role === 'ACCESS')?.registrationDate)}
        />
      ) : (
        <MyProfileStatusDisconnected
          qrCodeValue={registrationToken ? QRCodeValueUtil.getQrCodeValue(registrationToken) : null}
        />
      )}
    </DrawerTemplate>
  );
};
export default AccessApp;
